import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';
import { mergeCreditPlans } from '@/lib/billing/creditPlans';

export function useCreditPlans({ enabled = true } = {}) {
  const [apiPlans, setApiPlans] = useState([]);
  const [creditsPerInr, setCreditsPerInr] = useState(10);
  const [billingEnabled, setBillingEnabled] = useState(true);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) return [];
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get('/billing/plans');
      const items = Array.isArray(data?.items) ? data.items : [];
      const cpi = data?.credits_per_inr ?? 10;
      setApiPlans(items);
      setCreditsPerInr(cpi);
      setBillingEnabled(data?.billing_enabled !== false);
      return mergeCreditPlans(items, cpi);
    } catch (err) {
      setError(err);
      return mergeCreditPlans([], 10);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const plans = mergeCreditPlans(apiPlans, creditsPerInr);

  return { plans, apiPlans, creditsPerInr, billingEnabled, loading, error, refresh };
}
